import { FormBlockerElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'

import { getCheckboxElementKey } from '../ui/FormBlocker/elements/CheckboxElement/CheckboxElement'

type FulfilledRequirement = {
  fulfilled: true
  errorMsg?: undefined
}

type UnfulfilledRequirement = {
  fulfilled: false
  errorMsg?: string
}

type FulfillsRequirementsValidation = FulfilledRequirement | UnfulfilledRequirement

// getFormValue returns the value of a nested form value.
// Example: getFormValue(
//       '1.check_box_result.is_checked',
//       {
//         '1': { 'check_box_result': { 'is_checked': true } },
//         '2': { 'check_box_result': { 'is_checked': false } }
//       }
//     ) => true
type FormValues = Record<string, unknown>
function getFormValue(inputName: string, formValues: FormValues): unknown {
  const inputNameKeys = inputName.split('.')

  let drilledDownFormValue: unknown = formValues
  for (const key of inputNameKeys) {
    if (typeof drilledDownFormValue !== 'object' || drilledDownFormValue === null) {
      return false
    }

    if (!(key in drilledDownFormValue)) {
      return false
    }

    drilledDownFormValue = (drilledDownFormValue as FormValues)[key]
  }

  return drilledDownFormValue
}

/**
 * Validates that all fulfills_requirements groups have at least one checked checkbox.
 * Returns whether all requirements are fulfilled and the error message if not.
 */
export function validateFulfillsRequirements(
  elements: FormBlockerElement[],
  formValues: Record<string, unknown>
): FulfillsRequirementsValidation {
  // Map to track which requirements exist and if they're fulfilled
  const requirementsMap = new Map<string, { fulfilled: boolean; validationMessage?: string }>()

  elements.forEach((element, formSectionIndex) => {
    const checkboxElement = element.checkbox_element
    if (!checkboxElement?.fulfills_requirements || checkboxElement.fulfills_requirements.length === 0) {
      return
    }

    const checkboxRequirements = checkboxElement.fulfills_requirements
    const checkboxInputName = getCheckboxElementKey(formSectionIndex)
    const checkboxIsChecked = getFormValue(checkboxInputName, formValues) === true

    // Process each requirement this checkbox fulfills
    checkboxRequirements.forEach(checkboxReq => {
      const existing = requirementsMap.get(checkboxReq)
      if (!existing) {
        requirementsMap.set(checkboxReq, {
          fulfilled: checkboxIsChecked,
          validationMessage: checkboxElement.validation_message,
        })
      } else {
        if (checkboxIsChecked) {
          existing.fulfilled = true
        }
      }
    })
  })

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  for (const [_, value] of requirementsMap.entries()) {
    if (!value.fulfilled) {
      return {
        fulfilled: false,
        errorMsg: value.validationMessage,
      }
    }
  }

  return {
    fulfilled: true,
    errorMsg: undefined,
  }
}
